import { pagination } from 'app/utils/pagination';
import React from 'react';

export interface PaginateData {
  current_page: number;
  last_page: number;
  total: number;
}

const Paginate = ({ data, handleChangePage }) => {
  const { current_page, last_page } = data;
  const rangeWithDots = pagination(current_page, last_page);

  const changePage = (page) => {
    if (page) handleChangePage(page);
  }

  const pageButton = rangeWithDots.map((page, index) => {
    let classLiTag = "page-item ";
    if (data.current_page == page) classLiTag = classLiTag + "active ";
    if (page === '...') classLiTag = classLiTag + "disabled";

    return (
      <li key={index}
        className={classLiTag}
        onClick={() => changePage(data.current_page == page || page === '...' ? '' : page)}
      >
        <button className="page-link" style={{ zIndex: 1 }}>{page}</button>
      </li>
    )
  });

  const prevButton = () => {
    let classLiTag = "page-item ";
    if (data.current_page === 1) classLiTag = classLiTag + "disabled";

    return (
      <li className={classLiTag}
        onClick={() => changePage(data.current_page == 1 ? '' : data.current_page - 1)}
      >
        <button className="page-link">
          <span aria-hidden="true">&laquo;</span>
          <span className="sr-only">Previous</span>
        </button>
      </li>
    )
  }

  const nextButton = () => {
    let classLiTag = "page-item ";
    if (data.current_page === data.last_page) classLiTag = classLiTag + "disabled";

    return (
      <li className={classLiTag}
        onClick={() => changePage(data.current_page == data.last_page ? '' : data.current_page + 1)}
      >
        <button className="page-link">
          <span aria-hidden="true">&raquo;</span>
          <span className="sr-only">Next</span>
        </button>
      </li>
    )
  }

  return (
    <div className="row d-flex align-items-center mt-4">
      <div className="col-auto" style={{ margin: '0 auto' }}>
        <div className="paginate">
          <nav>
            <ul className="pagination small" style={{ margin: 0 }}>
              {prevButton()}
              {pageButton}
              {nextButton()}
            </ul>
          </nav>
        </div>
      </div>
      <style jsx global>{`
        .page-item.active .page-link:hover {
          color: #fff;
        }
      `}
      </style>
    </div>
  )
}

export default Paginate;
